import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Getting readership",
  "description": "",
  "published": "2008-08-28T00:00:00.000Z",
  "redirect_from": ["/blog/getting-readership/swizec/78"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Activity, activity, activity. Just as in the real estate world it's all about location, location, location in the blogosphere it's all about activity. The more active a blogger is the more readers they get and yes, while I do understand that there are people out there who aren't at all interested in having many readers some of us are quite vain and love readers almost as much as they like watching us dance like monkeys and do summersaults just to get that one more view. We're like spoilt attention seeking brats really ...`}</p>
    <p>{`But it's not just about activity, it's important what kind of activity you have. For example you can post every day, even more than once a day, and if what you're posting are just copy pastes of images or videos and your posts rarely contain any real content there won't be readers because, let's face it, they need to have something of value to read if you want them coming back. Don't fall into the quality over quantity scham though, there won't be any readers if they don't have something new to read at least a few times a week either.`}</p>
    <p>{`Another important aspect of getting a high readership is reading other people's blogs and commenting! Comments are good because they get your name out into the aether, alert other bloggers to your existance and, most of all, tell readers of blogs that hey, there's another guy out there whom they can check out.`}</p>
    <p>{`A good tactic, also, is getting a `}<a parentName="p" {...{
        "href": "http://technorati.com/claim/3h4sn3jvks"
      }}>{`Technorati Profile`}</a>{`, which gets your link out as well, also notifying other `}<a parentName="p" {...{
        "href": "blogorola.com"
      }}>{`online aggregators`}</a>{` can only be good. In fact I'd venture to say that the more aggregators that know about you the more readers know about you and there's bound to be some who decided they like you.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      